import { CriteriRicercaNotifiche } from 'civil-status/model/notifications';
import { ResearchNotifications } from 'civil-status/view-models/notifications-list';

export const transformNotificationsResearch = (
  values: ResearchNotifications
): CriteriRicercaNotifiche => {
  const data = values as ResearchNotifications;
  return {
    criteriRicercaNotifiche: {
      dataInizio: data.dateStart ? data.dateStart.toFormat('yyyy-MM-dd') : undefined,
      dataFine: data.dateEnd ? data.dateEnd.toFormat('yyyy-MM-dd') : undefined,
      idAnsc: data.idAnscNotification || undefined,
      idTipoEvento: data.typeEvent || undefined,
      idTipoContenuto: data.typeContent || undefined,
      idStatoFlussoNotifiche: data.stateNotification || undefined,
      idGenereNotifiche: data.typeNotifications || undefined,
      soggettoRicerca: {
        codiceFiscale: data.fiscalCode || undefined,
        cognome: data.surname || undefined,
        nome: data.name || undefined,
        datanascita: data.birthDate ? data.birthDate.toFormat('yyyy-MM-dd') : undefined,
        sesso: data.gender || undefined,
        idComuneNascita: data.municipality?.code || undefined,
        nomeComuneNascita: data.municipality?.description || undefined,
        siglaProvinciaNascita: data.municipality?.province || undefined,
        codiceStatoNascita: data.state?.id || undefined,
        nomeStatoNascita: data.state?.value || undefined,
        idAnscSoggetto: data.idAnsc || undefined,
        idAnpr: data.idAnpr || undefined,
      },
    },
  };
};
